import Card from './Card';

export default function StatCard({
  title,
  value,
  subtitle,
  icon,
  variant = 'default',
  valueColor,
  className = ''
}) {

  // Value color styles
  const valueColors = {
    primary: 'text-brand-primary',
    success: 'text-success',
    danger: 'text-danger',
    warning: 'text-warning',
    accent: 'text-accent',
    secondary: 'text-text-secondary',
    default: 'text-text-primary-light dark:text-primary'
  };

  const colorClass = valueColor ? valueColors[valueColor] || valueColor : valueColors.default;

  return (
    <Card variant={variant} padding="md" className={className}>
      <div className="flex items-start justify-between">
        <div className="flex-1">
          <h3 className="text-sm font-semibold text-text-secondary-light dark:text-secondary mb-2">
            {title}
          </h3>
          <p className={`text-4xl font-bold ${colorClass}`}>
            {value}
          </p>
          {subtitle && (
            <p className="text-sm text-text-muted-light dark:text-muted mt-2">
              {subtitle}
            </p>
          )}
        </div>
        {icon && (
          <div className="ml-4">
            {icon}
          </div>
        )}
      </div>
    </Card>
  );
}
